<template>
  <div class="main-content-container overflow-hidden">
    <PageTitle pageTitle="Data Category Store" subTitle="Forms" />

    <CreateCategroyStore />
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import PageTitle from "@/components/Common/PageTitle.vue";
import CreateCategroyStore from "@/components/Pages/Master/CategoryStore/CreateCategoryStore.vue";

export default defineComponent({
  name: "CreateCategoryStorePage",
  components: {
    PageTitle,
    CreateCategroyStore,
  },
});
</script>
